module.exports = __webpack_public_path__ + "static/img/icon-heal.28d207c6.svg";